import { render, staticRenderFns } from "./TelegramOtpTemplates.vue?vue&type=template&id=5d51da5b&"
import script from "./TelegramOtpTemplates.vue?vue&type=script&lang=ts&"
export * from "./TelegramOtpTemplates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports